import React, { Fragment } from 'react';
import MultiDetailDrillDown from 'components/multiDetailDrillDown';
import IntlMessages from 'util/IntlMessages';
import { formatBalance } from 'services/NumberFormatters';

/**
 * 
 * @param {Array} data of product objects
 */
const ProductDrillDown = ({ data, valueStreams }) => {
    let entries = new Array();
    if (Array.isArray(data)) {
        // need to convert data to label, description objects for use by basicDetailDrillDown
        entries = data.map((entry) => {
            const valueStream = Array.isArray(valueStreams) ? valueStreams.find(vs => vs?.id === entry?.valueStreamId) : null;
            return {
                name: entry?.name,
                drillDownData: [
                    { label: <IntlMessages id="label.description" />, description: entry?.description ? entry?.description : 'no description specified' },
                    { label: <IntlMessages id="label.valueStream" />, description: valueStream ? valueStream?.name : 'no value stream selected' },
                    { label: <IntlMessages id="label.fyBudget" />, description: entry?.fyBudget ? formatBalance(entry?.fyBudget) : formatBalance(0) },
                    { label: <IntlMessages id="label.productType" />, description: entry?.productType ? entry?.productType : 'no product type specified' },
                ]
            };
        });
        return (
            <div>
                <MultiDetailDrillDown entries={entries} />
            </div>
        );
    }
    return (
        <Fragment></Fragment>
    );
};

export default ProductDrillDown;


// WEBPACK FOOTER //
// ./components/agileDrillDowns/productDrillDown/index.js